// extracted by mini-css-extract-plugin
export var dropdown = "_og-1";
export var hidden = "_og-0";